module.exports = __webpack_public_path__ + "img/06.95d1c509.jpg";